var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    ixmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0-clock-svg {\r\n\t\t\tfill: none;\r\n\t\t}\r\n\r\n\t\t.st1-clock-svg {\r\n\t\t\tfill: #FFFFFF;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27 -173)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 173)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0-clock-svg",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1-clock-svg",
    d: "M10,20C4.5,20,0,15.5,0,10C0,4.5,4.5,0,10,0c5.5,0,10,4.5,10,10C20,15.5,15.5,20,10,20z M10,1c-5,0-9,4-9,9 c0,5,4,9,9,9c5,0,9-4,9-9C19,5,15,1,10,1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1-clock-svg",
    d: "M37,183.5h-2.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.3v-4.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.8 C37.5,183.3,37.3,183.5,37,183.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a4c5d8118ba43cf26012934298f4edd8.svg";
export { ForwardRef as ReactComponent };